import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PredesTransactionsReleaseDialog from './PredesTransactionsReleaseDialog';

class PredesTransactionsRelease extends Component {
  render() {
    return (
      <div>
        <PredesTransactionsReleaseDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

PredesTransactionsRelease.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default PredesTransactionsRelease;
